import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { MxDialogComponent } from './mx.dialog.component';

export const COMPONENTS: any[] = [
  MxDialogComponent,
];

@NgModule({
  imports: [CommonModule, PrimengModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class MxDialogModule {}
